<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>
<div class="row faixa-conteudo pt0">
  <div class="col col-lg-12">
    <div class="caixa">
      <div class="conteudo-caixa-sem-titulo sem-padding">
        <div class="row ptb50">
          <div class="col col-3">
            <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
              Data Inicial
            </div>
            <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
              styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
              yearRange="2000:2030" showButtonBar="true">
            </p-calendar>
          </div>
          <div class="col col-3">
            <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
              Data Final
            </div>
            <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
              styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
              yearRange="2000:2030" showButtonBar="true">
            </p-calendar>
          </div>
          <div class="col col-6">
            <button (click)="pesquisar()" pButton type="button" class="p-button-sm p-button-primary mt-3 mr-2">
              Filtrar
              <i class="pi pi-search ml-1"></i>
            </button>
            <button class="btn mt-3" type="button" style="background: #e0a800;" (click)="exibirFiltro()">
              Mais Filtros
              <em class="fa fa-filter"></em>
            </button>
            <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button" (click)="exportExcel()">
              <i class="fa fa-download mr-1"></i>Export Excel
            </button>
          </div>
        </div>
        <hr>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="display" [style]="{width: '550px'}">
  <form>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div class="col col-4"> Dealer </div>
        <div class="col col-6">
          <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
            <option translate value="">Selecione um dealer</option>
            <option *ngFor="let item of dealers" [value]="item.descricao">{{item.descricao}}</option>
          </select>
        </div>
      </div>
      <div class="row ptb5">
        <div class="col col-4"> CPF </div>
        <div class="col col-6">
          <input class="form-control form-control-sm" type="text" placeholder="CPF" [(ngModel)]="NumCpf">
        </div>
      </div>
      <div class="row ptb5">
        <div class="col col-4"> Somente com Restrição </div>
        <div class="switchRestricao">
          <label class="switch">
            <input type="checkbox" id="switch" checked>
            <span class="slider">
              <span class="on">Sim</span>
              <span class="off">Não</span>
            </span>
          </label>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info" (click)="filtroAPI()"> Filtrar </button>
  </ng-template>
</p-dialog>

<div class="content mt-3 col-12">
  <p-table #dt dataKey="idStatusServico" [value]="dados" selectionMode="multiple" [loading]="loading"
    styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines" [columns]="cols"
    [autoLayout]="true" id="excel-table" [rows]="50">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" style="background-color:black;color:white;">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-car>
      <tr>
        <td *ngFor="let col of cols">
          {{car[col.field]}}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator *ngIf="totalRegistros > 10" [rows]="tamanhoPagina" [(first)]="first" [totalRecords]="totalRegistros"
    [rowsPerPageOptions]="[10,20,30,50,100]" (onPageChange)="eventoPaginacao($event)" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registros">
  </p-paginator>
</div>